import local_config from './local.env';
import staging_config from './staging.env';
import prod_config from './prod.env';
import { IEnv } from '../interfaces/configInterface';

// eslint-disable-next-line import/no-mutable-exports
const config = (configEnv?: IEnv) => {
  let env: IEnv | undefined = configEnv;
  try {
    env ??= process.env.REACT_APP_ENV as IEnv
  } catch {}
  switch (env) {
    case 'development':
    case 'dev':
    case 'local':
      return local_config;
    case 'staging':
      return staging_config;
    default:
      return prod_config;
  }
};

export default config;
